// English source strings for M3: reception, arrival and departure, cards, badges, handover.
export const enM3 = {
  'api.walkInsDisabled': 'Walk-in registration is turned off for this site’s policy.',
  'api.notWalkIn': 'This visit was not registered as a walk-in.',
  'api.evaluationStale': 'The visitor’s details changed since you reviewed them. Review the current checks and try again.',
  'api.arrivalBlocked': 'This arrival cannot be recorded yet. Resolve the listed checks or record the visitor as waiting.',
  'api.notOnsite': 'This visitor is not recorded as onsite.',
  'api.alreadyOnsite': 'This visitor is already recorded as onsite.',
  'api.alreadyWaiting': 'This visitor is already waiting.',
  'api.waitingResolved': 'This wait has already ended.',
  'api.custodyTransition': 'A card cannot go from {from} to {to}.',
  'api.cardUnavailable': 'That card is no longer available. The inventory has been refreshed.',
  'api.cardAlreadyAssigned': 'This visitor already holds a card. Return it first.',
  'api.cardNotAssignable': 'A card can be assigned only to an approved visitor of a live visit.',
  'api.noCardAssigned': 'This visitor holds no card.',
  'api.badgeNotAllowed': 'A badge can be printed only for an approved visitor of a live visit.',
  'api.taskResolved': 'This task is already resolved.',
  'v.observedFuture': 'The time cannot be in the future.',
  'v.observedBeforeArrival': 'Departure cannot be before the recorded arrival.',
  'v.cardNumber': 'Use 1–40 letters, digits, dots, underscores or hyphens.',
  'v.cardNumberTaken': 'Another card at this site already uses this number.',
  'v.cardUnknown': 'Choose a card of this site.',
  'v.reprintReason': 'Give a reason for the reprint.',
  'v.notEditable': 'This detail cannot be changed here. Contact your host.',
  'v.noticeUnknown': 'This notice is not part of your visit.',
  'v.signatureRequired': 'Type your full name to sign.',
  'v.documentType': 'Use a PDF, JPEG or PNG file.',
  'custody.available': 'available',
  'custody.assigned': 'assigned',
  'custody.returned_held': 'returned (held)',
  'custody.lost': 'lost',
  'custody.disabled': 'disabled',
  'custody.maintenance': 'in maintenance',

  // ------------------------------------------------------------ reception UI
  'rcp.title': 'Reception',
  'rcp.intro': 'Know who is expected, resolve blockers and record actual movements.',
  'rcp.walkIn': 'Register walk-in',
  'rcp.date': 'Day',
  'rcp.today': 'Today',
  'rcp.pastNote': 'Showing presence as it was at the end of {date}, not today’s.',
  'rcp.m.expected': 'Expected',
  'rcp.m.expectedSub': 'Not yet observed today',
  'rcp.m.waiting': 'Waiting',
  'rcp.m.waitingSub': 'Arrived, not yet admitted',
  'rcp.m.onsite': 'Observed onsite',
  'rcp.m.onsiteSub': 'Presence, not inferred access',
  'rcp.m.exceptions': 'Exceptions',
  'rcp.m.exceptionsSub': 'Overdue or not arrived',
  'rcp.lookup': 'Find a visitor',
  'rcp.lookupHint': 'Scan the pass QR, or type a reference (V-…), card number, name, host or company.',
  'rcp.lookupGo': 'Find',
  'rcp.lookupNone': 'No matching visitor at this site.',
  'rcp.lookupDead': 'This pass link is no longer valid. Ask the visitor for their latest invitation or look them up by name.',
  'rcp.tab.expected': 'Expected arrivals',
  'rcp.tab.waiting': 'Waiting',
  'rcp.tab.onsite': 'Onsite',
  'rcp.tab.departed': 'Departed',
  'rcp.tab.exceptions': 'Exceptions',
  'rcp.queue': 'Reception queue',
  'rcp.queueSub': 'Check identity, approvals and pre-registration before arrival.',
  'rcp.empty': 'Nobody in this list.',
  'rcp.col.visitor': 'Visitor',
  'rcp.col.window': 'Window',
  'rcp.col.host': 'Host',
  'rcp.col.requirements': 'Requirements',
  'rcp.col.presence': 'Presence / access',
  'rcp.col.action': 'Next action',
  'rcp.review': 'Review & act',
  'rcp.flag.walkIn': 'Walk-in',
  'rcp.flag.early': 'Early',
  'rcp.flag.late': 'Late',
  'rcp.bucket.overdue': 'Overdue — no departure recorded',
  'rcp.bucket.not_arrived': 'Did not arrive',
  'rcp.card': 'Card {number}',
  'rcp.waitingSince': 'Waiting since {time} · {reason}',
  'rcp.rsvp.declined': 'Declined attendance',
  'rcp.handover': 'Desk handover',
  'rcp.handoverSub': 'Open work follows the record, not the operator.',
  'rcp.handoverNone': 'No open tasks.',
  'rcp.handoverAck': 'Acknowledge handover',
  'rcp.handoverNote': 'Handover note',
  'rcp.handoverDone': 'Handover acknowledged with {count} open tasks.',
  'rcp.handoverLast': 'Last handover: {by}, {when}',
  'rcp.task.waiting': 'Waiting visitor',
  'rcp.task.card_missing': 'Card not returned',
  'rcp.task.overstay': 'Overstay — no departure recorded',
  'rcp.task.print_unknown': 'Badge print outcome unknown',
  'rcp.task.departure_unconfirmed': 'Departure not confirmed',
  'rcp.task.other': 'Other',
  'rcp.taskResolve': 'Resolve',
  'rcp.taskResolution': 'What was done',
  // drawer
  'rcp.d.title': '{name}',
  'rcp.d.sub': '{reference} · host {host}',
  'rcp.d.checks': 'Arrival checks',
  'rcp.d.checksOk': 'All required checks pass.',
  'rcp.d.checksNote': 'Checks are re-run when you record the arrival.',
  'rcp.d.window': 'Window',
  'rcp.d.arrive': 'Record arrival',
  'rcp.d.observedAt': 'Observed time (optional)',
  'rcp.d.observedHint': 'Leave empty for now. Use only to record a moment that already happened.',
  'rcp.d.wait': 'Record as waiting',
  'rcp.d.waitReason': 'Waiting for',
  'rcp.d.waitChange': 'Change reason',
  'rcp.d.waitEnd': 'End wait',
  'rcp.d.waitEnded': 'Visitor left',
  'rcp.d.card': 'Physical card',
  'rcp.d.cardNone': 'No card assigned.',
  'rcp.d.cardAssign': 'Assign card',
  'rcp.d.cardChoose': 'Available card',
  'rcp.d.cardReturn': 'Card returned',
  'rcp.d.cardLost': 'Mark card lost',
  'rcp.d.cardLostReason': 'What happened',
  'rcp.d.badge': 'Badge',
  'rcp.d.badgePrint': 'Print badge',
  'rcp.d.badgeReprint': 'Reprint badge',
  'rcp.d.badgeReason': 'Reprint reason',
  'rcp.d.badgeAttempts': { one: '{count} print · last: {status}', other: '{count} prints · last: {status}' },
  'rcp.d.depart': 'Record departure',
  'rcp.d.departCard': 'Card {number}',
  'rcp.d.departCard.returned': 'Returned',
  'rcp.d.departCard.not_returned': 'Not returned',
  'rcp.d.departCard.lost': 'Lost',
  'rcp.d.departNote': 'Departure is recorded even if a card or access revocation is still open.',
  'rcp.d.history': 'Observed movements',
  'rcp.d.historyNone': 'No movements recorded.',
  'rcp.d.recordedBy': 'recorded by {name} at {when}',
  'rcp.d.arrival': 'Arrival',
  'rcp.d.departure': 'Departure',
  'rcp.d.openVisit': 'Open visit',
  'rcp.blocker.visit_not_submitted': 'The visit is not submitted.',
  'rcp.blocker.visit_cancelled': 'The visit is cancelled.',
  'rcp.blocker.visit_ended': 'The visit has ended.',
  'rcp.blocker.participant_removed': 'This person was removed from the visit.',
  'rcp.blocker.approval_pending': 'Approval is still pending.',
  'rcp.blocker.approval_rejected': 'Approval was rejected.',
  'rcp.blocker.host_confirmation_pending': 'The host has not confirmed this walk-in yet.',
  'rcp.blocker.window_not_open': 'The visit window has not opened yet.',
  'rcp.blocker.window_ended': 'The visit window has ended.',
  'rcp.blocker.already_onsite': 'Already recorded as onsite.',
  'rcp.blocker.reentry_not_allowed': 'Already checked out; re-entry is not allowed by policy.',
  'rcp.blocker.presence_unknown': 'Presence is uncertain; reconcile first.',
  'rcp.warning.early': 'Early arrival.',
  'rcp.warning.identity_evidence_missing': 'No accepted identity evidence (identity checks arrive with module 08).',
  'rcp.warning.attendance_declined': 'The visitor said they could not attend.',
  'rcp.blocker.contractor_not_eligible': 'Contractor checks are not met (evidence, affiliation, suspension or permit). See the contractor readiness on the visit.',
  'rcp.blocker.preregistration_incomplete': 'Pre-registration is not complete and this category requires it before arrival.',
  'rcp.warning.preregistration_incomplete': 'Pre-registration is not complete.',
  'rcp.reason.host': 'Host',
  'rcp.reason.approval': 'Approval',
  'rcp.reason.escort': 'Escort',
  'rcp.reason.evidence': 'Evidence',
  'rcp.reason.other': 'Other',
  // badge print
  'badge.title': 'Visitor badge',
  'badge.visitor': 'VISITOR',
  'badge.host': 'Host',
  'badge.validUntil': 'Valid until',
  'badge.print': 'Print',
  'badge.outcome': 'Did the badge print?',
  'badge.outcome.sent': 'Sent to printer',
  'badge.outcome.printed': 'Printed',
  'badge.outcome.failed': 'Failed',
  'badge.outcome.unknown': 'Not sure',
  'badge.note': 'Printing never issues an access credential.',
  // walk-in
  'walk.title': 'Register walk-in',
  'walk.sub': 'Unscheduled visits follow the same policy and approvals. The host confirms before arrival.',
  'walk.host': 'Host',
  'walk.category': 'Visitor category',
  'walk.purpose': 'Purpose',
  'walk.destination': 'Destination',
  'walk.until': 'Expected to leave by',
  'walk.untilHint': 'Today, site time. Defaults to the end of the day.',
  'walk.visitor': 'Visitor',
  'walk.returning': 'Returning visitor?',
  'walk.useProfile': 'Use this profile',
  'walk.create': 'Register',
  // host confirmation
  'walk.confirmTitle': 'Walk-in waiting for you',
  'walk.confirmBody': 'Reception registered this visitor without a prior invitation. Confirm that you expect them.',
  'walk.confirm': 'Confirm walk-in',
  'walk.confirmed': 'Confirmed {when}',
  // cards page
  'cards.title': 'Badges & access',
  'cards.intro': 'Physical card custody is tracked separately from logical access. A returned card is reused only when its access is confirmed inactive.',
  'cards.inventory': 'Card inventory',
  'cards.add': 'Add card',
  'cards.number': 'Card number',
  'cards.label': 'Label',
  'cards.col.card': 'Card',
  'cards.col.custody': 'Custody',
  'cards.col.holder': 'Held by',
  'cards.col.action': 'Action',
  'cards.disable': 'Disable',
  'cards.maintenance': 'Send to maintenance',
  'cards.enable': 'Make available',
  'cards.empty': 'No cards registered for this site.',
  'cards.logical': 'Logical access credentials and access-control integration arrive with module 11.',

  // Visitor pre-registration (module 05, PD-035).
  'prereg.title': 'Before your visit',
  'prereg.requiredBeforeArrival': 'Please complete these steps before you arrive. Reception cannot check you in until they are done.',
  'prereg.optionalBeforeArrival': 'Completing these steps now saves time at reception.',
  'prereg.complete': 'All done',
  'prereg.outstanding': '{count} to do',
  'prereg.status.complete': 'Done',
  'prereg.status.pending': 'To do',
  'prereg.status.declined': 'Declined',
  'prereg.status.rejected': 'Not accepted',
  'prereg.status.expired': 'Expired',
  'prereg.status.unavailable': 'Cannot be checked yet',
  'prereg.status.review_pending': 'Being checked',
  'prereg.contact': 'Your contact details',
  'prereg.name': 'Name',
  'prereg.email': 'Email',
  'prereg.phone': 'Phone',
  'prereg.organisation': 'Organisation',
  'prereg.maskedHint': 'Email and phone are partly hidden because this link may be forwarded. To change them, type the new value in full.',
  'prereg.contactCorrect': 'These details are correct',
  'prereg.contactChange': 'Change details',
  'prereg.saveContact': 'Save and confirm',
  'prereg.field.givenName': 'Given name',
  'prereg.field.familyName': 'Family name',
  'prereg.field.email': 'New email',
  'prereg.field.phone': 'New phone number',
  'prereg.field.organisation': 'Organisation',
  'prereg.noticeUnavailable': 'This notice has not been published yet. Your host will contact you.',
  'prereg.noticeVersion': 'Version {number}',
  'prereg.purpose': 'Why we ask',
  'prereg.signedName': 'Type your full name to sign',
  'prereg.signedNameHint': 'Your typed name, the notice version and the time are recorded as your signature.',
  'prereg.sign': 'Sign',
  'prereg.accept': 'I have read and accept',
  'prereg.declineNotice': 'I do not accept',
  'prereg.declinedHint': 'You declined this notice. Your host and reception will see that it is not accepted. You can accept it later if you change your mind.',
  'prereg.chooseFile': 'Choose a file',
  'prereg.replaceFile': 'Replace the file',
  'prereg.fileHint': 'PDF, JPEG or PNG, up to 10 MB.',
  'prereg.upload': 'Upload',
  'prereg.uploading': 'Uploading…',
  'prereg.doc.complete': 'Accepted.',
  'prereg.doc.review_pending': 'Received and waiting to be checked.',
  'prereg.doc.unavailable': 'Received, but documents cannot be checked yet at this site. Reception will help you on arrival.',
  'prereg.doc.rejected': 'This document was not accepted. Please upload a new one.',
  'prereg.doc.expired': 'This document has expired. Please upload a current one.',
  'prereg.doc.declined': 'Declined.',
  'prereg.readiness': 'Pre-registration',
  'prereg.readiness.complete': 'Complete',
  'prereg.readiness.outstanding': '{count} outstanding',

  // Policy editor: pre-registration (PD-035) and reception rules (PD-030); notices (PB-05-03/04).
  'vpolicy.col.preRegistration': 'Before arrival',
  'vpolicy.pr.title': 'Visitor pre-registration',
  'vpolicy.pr.hint': 'What visitors in this category complete from their pass link before arriving.',
  'vpolicy.pr.confirmContact': 'Visitor confirms contact details',
  'vpolicy.pr.requiredBeforeArrival': 'Must be complete before reception can record arrival',
  'vpolicy.pr.editable': 'Details the visitor may correct',
  'vpolicy.pr.field.email': 'Email',
  'vpolicy.pr.field.phone': 'Phone',
  'vpolicy.pr.field.organisation': 'Organisation',
  'vpolicy.pr.field.name': 'Name',
  'vpolicy.pr.nameWarning': 'A visitor-made name change is recorded as identity-relevant and must be checked at reception.',
  'vpolicy.pr.notices': 'Notices to accept or sign',
  'vpolicy.pr.noNotices': 'No notices yet. Create one under Notices below.',
  'vpolicy.pr.noticeMissing': 'Not published',
  'vpolicy.pr.documents': 'Documents to upload',
  'vpolicy.pr.docKey': 'Document key',
  'vpolicy.pr.docRequired': 'Required',
  'vpolicy.pr.addDocument': 'Add document',
  'vpolicy.pr.removeDocument': 'Remove',
  'vpolicy.pr.scannerNote': 'Uploaded documents stay “cannot be checked yet” until a malware scanner and a reviewer are configured, so a required document will keep the visit incomplete.',
  'vpolicy.pr.contactShort': 'contact check',
  'vpolicy.pr.noticesShort': '{count} notice(s)',
  'vpolicy.pr.documentsShort': '{count} document(s)',
  'vpolicy.pr.requiredShort': 'required before arrival',
  'vpolicy.rcp.title': 'Reception rules',
  'vpolicy.rcp.early': 'Earliest arrival before the window',
  'vpolicy.rcp.grace': 'Overstay grace after the window',
  'vpolicy.rcp.minutesHint': 'In minutes.',
  'vpolicy.rcp.minutes': '{count} min',
  'vpolicy.rcp.reentry': 'Allow re-entry after checkout in the same window',
  'vpolicy.rcp.walkIns': 'Walk-in registration',
  'vpolicy.rcp.hostConfirm': 'Walk-ins need host confirmation before arrival',
  'vpolicy.rcp.walkInsConfirm': 'Yes, with host confirmation',
  'notice.title': 'Notices',
  'notice.intro': 'Versioned texts visitors accept or sign. Published versions never change; publish a new version instead.',
  'notice.new': 'New notice',
  'notice.newVersion': 'New version',
  'notice.newVersionOf': 'New version of {key}',
  'notice.draftHint': 'Saved as a draft. Visitors see it only after it is published.',
  'notice.empty': 'No notices yet.',
  'notice.col.notice': 'Notice',
  'notice.col.kind': 'Type',
  'notice.kind.acknowledgement': 'Acknowledgement',
  'notice.kind.signature': 'Signature',
  'notice.status.draft': 'Draft',
  'notice.status.published': 'Published',
  'notice.status.retired': 'Retired',
  'notice.siteOnly': 'this site only',
  'notice.publish': 'Publish',
  'notice.key': 'Key',
  'notice.keyHint': 'Lower-case letters, digits and hyphens. The policy refers to notices by key.',
  'notice.bodyEn': 'Text (English)',
  'notice.bodyAr': 'Text (Arabic)',
  'notice.purpose': 'Why the signature is needed',
  'notice.purposeHint': 'Shown to the visitor with the signature request.',
  'notice.reaccept': 'People who accepted an earlier version must accept this one again',
  'notice.saveDraft': 'Save draft',

  // Self-service kiosk (module 05, PD-040, PD-041).
  'api.kioskNotPaired': 'This screen is not set up as a kiosk. Ask a site administrator to pair it.',
  'api.kioskPairingInvalid': 'That pairing code is not valid or has expired.',
  'api.kioskRevoked': 'This kiosk has been revoked.',
  'api.kioskHostUnknown': 'Choose one of the hosts offered at this kiosk.',
  'api.kioskSessionEnded': 'This session has ended. Please start again.',
  'api.kioskFeatureOff': 'This option is not available at this kiosk.',
  'api.kioskPaused': 'This kiosk is paused for a few minutes. Please go to reception.',
  'api.kioskNotFound': 'We could not find your visit. Check the details or ask reception for help.',
  'api.kioskChanged': 'Your visit details changed. Please review them and try again.',
  'api.kioskSeeReception': 'Please go to reception to complete your arrival.',
  'v.pairingCode': 'Enter the 8-character code, for example ABCD-2345.',
  'v.reference': 'Enter the reference shown on your pass, for example V-8FD8C5.',
  'rcp.task.kiosk_assistance': 'Help requested at a kiosk',
  'rcp.task.kiosk_walk_in': 'Walk-in request from a kiosk',

  // Kiosk screens (PB-05-09..12, OR-04).
  'kiosk.pair.title': 'Set up this kiosk',
  'kiosk.pair.body': 'Enter the pairing code a site administrator created under Sites → Kiosks.',
  'kiosk.pair.code': 'Pairing code',
  'kiosk.pair.submit': 'Pair this screen',
  'kiosk.eyebrow': '{site} · Welcome',
  'kiosk.welcome.title': 'Welcome. Check in here.',
  'kiosk.welcome.body': 'Choose your language, then follow the steps. Reception is always happy to help.',
  'kiosk.language': 'Language',
  'kiosk.checkIn': 'I have an invitation',
  'kiosk.checkOut': 'I am leaving',
  'kiosk.walkIn': 'I don’t have an invitation',
  'kiosk.help': 'I need assistance',
  'kiosk.privacy': 'This screen clears itself after {count} seconds without activity. Nothing you enter is kept on this device.',
  'kiosk.find.titleIn': 'Find your invitation',
  'kiosk.find.titleOut': 'Check out',
  'kiosk.find.body': 'Scan the QR code on your pass, or enter your visit reference.',
  'kiosk.find.scan': 'Scan your pass',
  'kiosk.find.scanPlaceholder': 'Hold your QR code to the scanner',
  'kiosk.find.camera': 'Use the camera',
  'kiosk.find.cameraFailed': 'The camera could not be used. Enter your reference instead, or ask for help.',
  'kiosk.find.continue': 'Continue',
  'kiosk.find.orReference': 'Or enter your reference',
  'kiosk.find.reference': 'Visit reference (on your pass)',
  'kiosk.find.checkName': 'Your first or last name',
  'kiosk.find.checkPhone': 'Last 4 digits of your phone number',
  'kiosk.back': 'Back',
  'kiosk.cancel': 'Cancel',
  'kiosk.finish': 'Finish',
  'kiosk.hello': 'Hello, {name}.',
  'kiosk.reference': 'Reference',
  'kiosk.confirmIn': 'Check in now',
  'kiosk.confirmOut': 'Check out now',
  'kiosk.cardReturn': 'Please hand your visitor card to reception or drop it in the card box.',
  'kiosk.req.body': 'Before you check in, please read and respond to the following.',
  'kiosk.req.reception': 'Some steps can only be completed with reception. Please ask for assistance.',
  'kiosk.outcome.too_early': 'You are early.',
  'kiosk.outcome.too_early_body': 'Self check-in opens shortly before {time}. Please take a seat or ask reception.',
  'kiosk.outcome.ended': 'This visit is no longer active.',
  'kiosk.outcome.already_onsite': 'You are already checked in.',
  'kiosk.outcome.see_reception': 'Please see reception.',
  'kiosk.outcome.not_onsite': 'You are not checked in.',
  'kiosk.outcome.requirements': 'A few steps remain.',
  'kiosk.outcome.ready': 'Ready.',
  'kiosk.outcome.checked_in': 'Checked in.',
  'kiosk.outcome.checked_out': 'Checked out.',
  'kiosk.outcome.reception': 'Reception will help you complete your arrival. You can ask for assistance below.',
  'kiosk.done.inTitle': 'Welcome, {name}. You are checked in.',
  'kiosk.done.inBody': '{host} is being told you have arrived.',
  'kiosk.done.badge': 'Please collect your visitor badge at reception.',
  'kiosk.done.outTitle': 'Thank you for visiting, {name}.',
  'kiosk.done.card': 'Please return your visitor card to reception.',
  'kiosk.helpComing': 'Reception has been told and will be with you shortly.',
  'kiosk.idle.title': 'Are you still there?',
  'kiosk.idle.body': { one: 'For your privacy this screen will clear in {count} second.', other: 'For your privacy this screen will clear in {count} seconds.' },
  'kiosk.idle.continue': 'Continue',
  'kiosk.walkin.body': 'Tell us who you are here to see. Reception will register your visit with your host.',
  'kiosk.walkin.host': 'Who are you visiting?',
  'kiosk.walkin.purpose': 'Reason for your visit',
  'kiosk.walkin.submit': 'Ask reception',
  'kiosk.doneNote.help': 'Help is on the way.',
  'kiosk.doneNote.helpBody': 'Reception has been told. Please wait here or go to the desk.',
  'kiosk.doneNote.walkin': 'Thank you. Reception has your request.',
  'kiosk.doneNote.walkinBody': 'Please take a seat. Reception will contact your host and help you check in.',
  'kiosk.doneNote.ended': 'This session has ended.',
  'kiosk.doneNote.endedBody': 'For your privacy the screen was cleared. Please start again.',
  // Site → Kiosks (administration).
  'sites.tab.kiosks': 'Kiosks',
  'kiosks.title': 'Self-service kiosks',
  'kiosks.intro': 'Shared screens where visitors check in. Each kiosk is paired once with a code and can be revoked at any time.',
  'kiosks.add': 'Add kiosk',
  'kiosks.empty': 'No kiosks at this site.',
  'kiosks.col.kiosk': 'Kiosk',
  'kiosks.col.status': 'Status',
  'kiosks.col.offers': 'Offers',
  'kiosks.col.seen': 'Last seen',
  'kiosks.idle': 'Clears after {seconds} s',
  'kiosks.status.pending': 'Waiting to pair',
  'kiosks.status.active': 'Active',
  'kiosks.status.revoked': 'Revoked',
  'kiosks.offer.checkIn': 'Check-in',
  'kiosks.offer.checkout': 'Self-checkout',
  'kiosks.offer.walkIn': 'Walk-in requests',
  'kiosks.offer.notices': 'Notices',
  'kiosks.settings': 'Settings',
  'kiosks.newCode': 'New pairing code',
  'kiosks.revoke': 'Revoke',
  'kiosks.editTitle': 'Kiosk settings: {name}',
  'kiosks.dialogHint': 'Changes apply the next time the kiosk loads (within five minutes).',
  'kiosks.name': 'Name',
  'kiosks.nameHint': 'Where the screen stands, for example “Lobby, east entrance”.',
  'kiosks.defaultLocale': 'Starting language',
  'kiosks.lookupCheck': 'Second check with a typed reference',
  'kiosks.lookupCheckHint': 'A reference alone never finds a visit.',
  'kiosks.lookup.name': 'First or last name',
  'kiosks.lookup.phone_last4': 'Last 4 digits of phone',
  'kiosks.idleSeconds': 'Clear the screen after',
  'kiosks.warningSeconds': 'Warn before clearing',
  'kiosks.secondsHint': 'In seconds.',
  'kiosks.offersLegend': 'What this kiosk offers',
  'kiosks.escalate': 'Send to reception instead of self check-in when',
  'kiosks.badge': 'After check-in',
  'kiosks.badge.collect_at_reception': 'Ask the visitor to collect a badge at reception',
  'kiosks.badge.none': 'No badge message',
  'kiosks.walkInHosts': 'Hosts offered for walk-in requests',
  'kiosks.walkInHostsHint': 'Only these names are shown on the kiosk; nothing else of the directory is visible.',
  'kiosks.createAndPair': 'Create and show pairing code',
  'kiosks.pairTitle': 'Pair {name}',
  'kiosks.pairHint': 'The code is shown once and works for 30 minutes.',
  'kiosks.pairStep1': 'On the kiosk screen, open',
  'kiosks.pairStep2': 'Enter this code:',
  'kiosks.pairValid': 'Valid until {time}',
  'kiosks.pairOnce': 'Pairing again later replaces the device credential and ends any open visitor session.',
  'kiosks.pairDone': 'Done',
  'kiosks.revokeTitle': 'Revoke {name}',
  'kiosks.revokeHint': 'The kiosk stops working immediately and any open visitor session ends.',
  'kiosks.revokeReason': 'Reason',

  // Communications (module 13, PD-045..PD-048).
  'api.alreadyVoted': 'You have already decided on this approval.',
  'v.groupUnknown': 'Choose an active approver group.',
  'v.groupEmpty': 'This approver group has no members, so the stage could never be decided.',
  'v.policyTimerOrder': 'Escalation must come before expiry.',
  'v.delegateSelf': 'Choose someone other than the person delegating.',
  'v.delegationTooLong': 'A delegation can last at most 90 days.',
  'api.delegationRevoked': 'This delegation has already been revoked.',
  'specialist.protocol-officer': 'Protocol officer',
  'v.escortConfirm': 'Confirm that the escort is present before recording the arrival.',
  'rcp.blocker.escort_unassigned': 'This visitor type needs an escort, and none is assigned.',
  'rcp.warning.escort_confirmation': 'An escort is required: confirm they are present.',
  'v.hostInactive': 'Choose an active host.',
  'v.templateVariable': 'Unknown variable(s) for this template: {names}.',
  'v.channelNotUsed': 'This organisation does not send messages on that channel.',
  'v.providerTemplate': 'Use the provider’s template name: lower-case letters, digits and underscores.',
  'tpl.status.draft': 'Draft',
  'tpl.status.approved': 'Approved',
  'tpl.status.retired': 'Retired',

  // Communications workspace and notification rules (module 13).
  'comms.title': 'Communications',
  'comms.intro': 'Message templates in English and Arabic, and the delivery log. Which channels each event uses is set in Policies & workflows.',
  'comms.scope': 'Applies to',
  'comms.tabs': 'Communications views',
  'comms.tab.templates': 'Templates',
  'comms.tab.log': 'Delivery log',
  'comms.templates': 'Message templates',
  'comms.templatesSub': 'Organisation or site versions replace the built-in text once approved. Each language is approved separately.',
  'comms.newTemplate': 'New template',
  'comms.newVersion': 'New version',
  'comms.newVersionOf': 'New version: {name}',
  'comms.draftHint': 'Saved as a draft. Recipients see it only after it is approved.',
  'comms.empty': 'No organisation templates yet; the built-in texts are in use.',
  'comms.emptySite': { zero: 'No site-specific templates; organisation or built-in texts apply here.', one: 'No site-specific templates; 1 organisation template applies here.', other: 'No site-specific templates; {count} organisation templates apply here.' },
  'comms.noTemplateScope': 'You can view the delivery log but not manage templates.',
  'comms.perLocale': 'Approving one language never approves the other. If a recipient’s language has no approved or built-in version, the message is blocked unless a fallback language is set in the policy.',
  'comms.col.message': 'Message',
  'comms.col.channel': 'Channel',
  'comms.col.language': 'Language',
  'comms.col.inUse': 'In use',
  'comms.col.draft': 'Draft',
  'comms.col.time': 'Time',
  'comms.col.recipient': 'Recipient',
  'comms.col.status': 'Status',
  'comms.col.attempts': 'Attempts',
  'comms.version': 'Version {number}',
  'comms.builtIn': 'Built-in',
  'comms.segments': { one: '{count} SMS segment', other: '{count} SMS segments' },
  'comms.approve': 'Approve',
  'comms.subject': 'Subject',
  'comms.bodyText': 'Text',
  'comms.bodyWhatsapp': 'Template parameters (in order)',
  'comms.bodyHtml': 'HTML (optional)',
  'comms.bodyHtmlHint': 'Leave empty to send the text inside the standard branded layout.',
  'comms.variables': 'Variables: {names}',
  'comms.providerTemplate': 'Provider template name',
  'comms.providerTemplateHint': 'The name of the template approved by the WhatsApp provider. Free text is never sent.',
  'comms.note': 'Change note',
  'comms.preview': 'Preview',
  'comms.previewTitle': 'Preview with sample data',
  'comms.unknownVariables': 'Unknown variables: {names}. Saving will be refused.',
  'comms.smsPreview': { one: '{count} segment · {units} characters · {per} per segment · {encoding}. The full text is always sent, never cut.', other: '{count} segments · {units} characters · {per} per segment · {encoding}. The full text is always sent, never cut; each segment may be charged.' },
  'comms.whatsappPreviewHint': 'WhatsApp sends the provider template with these values as its parameters, in this order.',
  'comms.saveDraft': 'Save draft',
  'comms.log': 'Delivery log',
  'comms.logSub': 'What happened to each message. Recipients are partly hidden.',
  'comms.site': 'Site',
  'comms.allStatuses': 'All statuses',
  'comms.logEmpty': 'No messages for this site yet.',
  'comms.acceptedNote': '“Accepted” means the provider took the message. It does not mean it was read, and it never means a visit or arrival was approved.',
  'comms.key.invitation': 'Invitation',
  'comms.key.reminder': 'Reminder',
  'comms.key.cancellation': 'Cancellation',
  'comms.key.host_arrival': 'Arrival notice to host',
  'comms.key.rsvp_reply': 'Attendance reply to host',
  'comms.key.approval_requested': 'Approval request',
  'comms.key.approval_decided': 'Approval outcome to host',
  'comms.key.parking_change': 'Parking change',
  'comms.key.gate_host_contact': 'Gate contact to host',
  'comms.channel.email': 'Email',
  'comms.channel.sms': 'SMS',
  'comms.channel.whatsapp': 'WhatsApp',
  'comms.status.queued': 'Queued',
  'comms.status.accepted': 'Accepted',
  'comms.status.failed': 'Failed',
  'comms.status.blocked': 'Blocked',
  'comms.reason.no_consent': 'No consent from the visitor',
  'comms.reason.template_unapproved': 'No approved provider template',
  'comms.reason.template_locale_missing': 'No version in the recipient’s language',
  'comms.reason.channel_unavailable': 'No provider configured for this channel',
  'comms.reason.opted_out': 'The visitor opted out of this channel',
  'comms.reason.superseded': 'A newer link was issued',
  'vpolicy.ntf.title': 'Notifications',
  'vpolicy.ntf.hint': 'Which channels each event uses. SMS and WhatsApp need a provider (not chosen yet); until then those sends are recorded as blocked.',
  'vpolicy.ntf.categoryTitle': 'Notifications for this category',
  'vpolicy.ntf.categoryHint': 'Tick “Override” to change an event for this category only; otherwise the organisation setting applies.',
  'vpolicy.ntf.trigger': 'Event',
  'vpolicy.ntf.override': 'Override',
  'vpolicy.ntf.overrideFor': 'Override {name}',
  'vpolicy.ntf.on': 'On',
  'vpolicy.ntf.onFor': 'Send {name}',
  'vpolicy.ntf.staff': 'to staff',
  'vpolicy.ntf.visitor': 'to the visitor',
  'vpolicy.ntf.t.invitation': 'Invitation',
  'vpolicy.ntf.t.reminder': 'Reminder before the visit',
  'vpolicy.ntf.t.cancellation': 'Cancellation',
  'vpolicy.ntf.t.host_arrival': 'Visitor arrived',
  'vpolicy.ntf.t.rsvp_reply': 'Visitor’s attendance reply',
  'vpolicy.ntf.t.approval_requested': 'Approval needed',
  'vpolicy.ntf.t.approval_decided': 'Approval outcome',
  'vpolicy.ntf.reminderHours': 'Send the reminder this many hours before',
  'vpolicy.ntf.reminderHoursHint': 'Between 1 and 168.',
  'vpolicy.ntf.fallback': 'If a language version is missing',
  'vpolicy.ntf.fallbackHint': 'By default such a message is blocked rather than sent in another language.',
  'vpolicy.ntf.fallbackNone': 'Block the message',
  'vpolicy.ntf.providerNote': 'WhatsApp is only for visitors who opted in, and only with an approved provider template. Staff notices never use WhatsApp.',
  'pass.consent.title': 'Message preferences',
  'pass.consent.intro': 'You can also get updates about this visit by:',
  'pass.consent.sms': 'Text message (SMS)',
  'pass.consent.whatsapp': 'WhatsApp',
  'pass.consent.saved': 'Saved.',

  // Approval workflows (module 07, PD-049..PD-053).
  'vpolicy.addFromTemplate': 'Add from a starting template',
  'vpolicy.chooseTemplate': 'Choose a visitor type…',
  'vpolicy.templatesHint': 'Templates are starting points only: everything stays editable and is versioned with the policy.',
  'vpolicy.quorum': 'Approvals needed',
  'vpolicy.quorumHint': 'Distinct people who must approve; one rejection rejects.',
  'vpolicy.escalateAfter': 'Alert coordinators after',
  'vpolicy.expiresAfter': 'Expire after',
  'vpolicy.hoursOptional': 'Hours waiting for a decision; leave empty for no limit.',
  'vpolicy.resolver.groups': 'Approver groups',
  'vpolicy.resolver.group': 'Group',
  'vpolicy.resolver.people': 'Named people',
  'vpolicy.typeHandling': 'Handling for this visitor type',
  'vpolicy.escortRequired': 'Needs an escort confirmed at arrival',
  'vpolicy.restrictedVisibility': 'Restricted visibility (hosts, approvers, reception and protocol officers only)',
  'vpolicy.kioskSelfService': 'May use self-service kiosks',
  'vpolicy.typeHandlingHint': 'These settings never bypass approval, identity or other arrival checks.',
  'wf.choose': 'Choose…',
  'wf.quorumProgress': '{done} of {of} approvals',
  'wf.escalated': 'Overdue',
  'wf.groupStage': 'Group: {name}',
  'wf.actingFor': 'Decided on behalf of {name}',
  'wf.alreadyVoted': 'You have decided',
  'wf.groups.title': 'Approver groups',
  'wf.groups.intro': 'Who approves which visits, by site, host department, destination or visitor type. Stages can be assigned to a group.',
  'wf.groups.new': 'New group',
  'wf.groups.empty': 'No approver groups yet.',
  'wf.groups.noMembers': 'No members',
  'wf.groups.memberCount': { one: '1 member', other: '{count} members' },
  'wf.groups.addMember': 'Add member',
  'wf.groups.addTo': 'Add to {name}',
  'wf.groups.scopeHint': 'Leave a scope field empty to cover everything. The person must also hold the approver role where the visit takes place.',
  'wf.groups.col.person': 'Person',
  'wf.groups.col.scope': 'Applies to',
  'wf.groups.col.canDecide': 'Can decide',
  'wf.groups.noApproverRole': 'No approver role',
  'wf.groups.remove': 'Remove',
  'wf.groups.hint': 'A policy cannot be published with a stage assigned to an empty or unknown group. Hosts and creators never decide their own visits.',
  'wf.scope.anySite': 'Any site',
  'wf.scope.siteLabel': 'Site',
  'wf.scope.department': 'department {name}',
  'wf.scope.departmentLabel': 'Host department',
  'wf.scope.departmentHint': 'Matches the primary host’s department.',
  'wf.scope.location': 'within {name}',
  'wf.scope.type': 'type {code}',
  'wf.scope.typeLabel': 'Visitor type code',
  'wf.scope.typeHint': 'For example business or contractor.',
  'wf.del.title': 'Delegations while away',
  'wf.del.intro': 'Let another approver decide for you during a period. They act only where they may approve themselves.',
  'wf.del.new': 'Delegate my approvals',
  'wf.del.empty': 'No delegations.',
  'wf.del.col.from': 'Delegated by',
  'wf.del.col.to': 'Delegate',
  'wf.del.col.when': 'Period',
  'wf.del.active': 'Active',
  'wf.del.inactive': 'Not active',
  'wf.del.revoked': 'Revoked',
  'wf.del.revoke': 'Revoke',
  'wf.del.from': 'From',
  'wf.del.until': 'Until',
  'wf.del.save': 'Delegate',
  'wf.del.dialogHint': 'Up to 90 days. Decisions record that they were made on your behalf.',
  'wf.del.reason': 'Reason',
  'wf.del.reasonHint': 'Recorded in the audit trail, for example annual leave.',
  'wf.del.hint': 'A delegate can never decide a visit they host or created, even on someone else’s behalf.',
  'wf.escort.title': 'Escort',
  'wf.escort.required': 'This visitor type needs an escort; reception confirms they are present at arrival.',
  'wf.escort.optional': 'An escort is named for this visit.',
  'wf.escort.assign': 'Name an escort',
  'wf.escort.change': 'Change escort',
  'wf.escort.none': 'No escort named yet. The visitor waits at reception until one is.',
  'wf.escort.since': 'since {when}',
  'wf.escort.person': 'Escort',
  'wf.escort.dialogHint': 'The previous escort, if any, is kept in the history.',
  'wf.escort.confirmPresent': 'The escort is present to receive the visitor',
  // Configuration dictionary (OR-10, PD-055/PD-056).
  'v.siteUnknown': 'Choose one of your sites.',
  'v.purposeCodeTaken': 'This code is already used in this scope.',
  'v.purposeUnknown': 'Choose a purpose from the list for this site and visitor type.',
  'v.purposeRetired': 'This purpose has been retired. Choose a current one.',
  'v.personOtherSite': 'This person is known at another site, and this site does not reuse profiles from other sites. Add them as a new visitor.',
  'v.guidanceEmpty': 'Fill in at least one kind of guidance.',
  'v.locationUnknown': 'Choose a location at this site.',
  'api.guidanceRetired': 'This guidance has already been replaced or retired.',
  'api.noPolicyOverride': 'This site has no policy of its own; it already follows the shared policy.',
  'api.siteContextMismatch': 'This record belongs to a different site from your working site. Switch to its site and try again, or start again at your working site.',
  'api.impactChanged': 'Something changed since you reviewed the impact (for example a new booking). Review it again.',
  'api.locationDependencies': 'Move its planned visits and disable its access-zone mappings first.',
  'api.locationPolicyReferences': 'Confirm that the listed rules for this location will stop applying.',
  'v.deskUnknown': 'Choose an active desk at this site.',
  'v.purposeFromList': 'Visitors of this type take their purpose from the list.',
  // Organisation configuration (OR-10, PD-055/PD-056).
  'cfg.tab': 'Organisation configuration',
  'cfg.title': 'Organisation configuration',
  'cfg.intro': 'The reference lists Passage uses, where each one is managed, and the values kept here. Retired values stay in history; nothing is deleted.',
  'cfg.areas.title': 'Reference lists',
  'cfg.areas.intro': 'Each list is changed where it belongs, under that area’s permissions. This page shows them together.',
  'cfg.col.area': 'List',
  'cfg.col.current': 'Current',
  'cfg.col.managed': 'Managed in',
  'cfg.col.action': 'Action',
  'cfg.manage': 'Manage',
  'cfg.view': 'View',
  'cfg.edit': 'Edit',
  'cfg.area.sites': 'Company and sites',
  'cfg.area.sites.hint': 'Sites, addresses, countries, time zones and branding.',
  'cfg.area.sites.summary': '{active} active · {inactive} inactive',
  'cfg.area.categories': 'Visitor types',
  'cfg.area.categories.hint': 'Categories, required details and approval stages (versioned policy).',
  'cfg.area.categories.summary': 'Policy version {version} · {active} active types',
  'cfg.area.purposes': 'Visit purposes',
  'cfg.area.purposes.hint': 'The list hosts choose from, where a visitor type asks for it.',
  'cfg.area.purposes.summary': '{active} in use · {retired} retired',
  'cfg.area.id_types': 'Visitor ID types',
  'cfg.area.id_types.hint': 'Accepted identity documents (identity verification settings).',
  'cfg.area.id_types.summary': '{enabled} accepted · {disabled} not accepted · settings version {version}',
  'cfg.area.qr': 'Pass and re-entry',
  'cfg.area.qr.hint': 'Re-entry after checkout and early-arrival window (reception rules of the visitor policy).',
  'cfg.area.qr.summary': 'Re-entry after checkout: {reentryAfterCheckout} · early arrival {earlyArrivalMinutes} min',
  'cfg.area.session': 'Sign-in and session',
  'cfg.area.session.hint': 'Idle and absolute session limits and multi-factor requirement.',
  'cfg.area.session.summary': 'Idle {idleMinutes} min · absolute {absoluteHours} h · MFA: {mfa} · source: {source}',
  'cfg.area.session.owner': 'Set by the system administrator; organisations can read it.',
  'cfg.area.display': 'Date and time format',
  'cfg.area.display.hint': 'How dates and times appear for everyone in the organisation.',
  'cfg.area.display.summary': '{dateStyle} · {hourCycle}',
  'cfg.value.yes': 'yes',
  'cfg.value.no': 'no',
  'cfg.value.none': 'not required',
  'cfg.value.administrators': 'administrators',
  'cfg.value.all': 'everyone',
  'cfg.value.platform': 'platform default',
  'cfg.value.organisation': 'organisation',
  'cfg.value.medium': 'Medium date',
  'cfg.value.long': 'Long date',
  'cfg.value.numeric': 'Numeric date',
  'cfg.value.iso': 'ISO date',
  'cfg.value.locale': 'language clock',
  'cfg.value.h23': '24-hour clock',
  'cfg.value.h12': '12-hour clock',
  'cfg.purpose.intro': 'Values for organisation-wide use or for one site. A site value with the same code replaces the organisation value at that site.',
  'cfg.purpose.new': 'New purpose',
  'cfg.purpose.editTitle': 'Edit purpose',
  'cfg.purpose.dialogHint': 'The code never changes. Labels and visitor types can be edited; visits keep the text they were saved with.',
  'cfg.purpose.empty': 'No purposes yet. Visitor types use free text until a list exists.',
  'cfg.purpose.col.purpose': 'Purpose',
  'cfg.purpose.col.scope': 'Applies to',
  'cfg.purpose.col.types': 'Visitor types',
  'cfg.purpose.col.status': 'Status',
  'cfg.purpose.everySite': 'Every site',
  'cfg.purpose.everyType': 'Every type',
  'cfg.purpose.active': 'In use',
  'cfg.purpose.retired': 'Retired',
  'cfg.purpose.retire': 'Retire',
  'cfg.purpose.restore': 'Bring back',
  'cfg.purpose.usedBy': { one: 'Held by 1 visit', other: 'Held by {count} visits' },
  'cfg.purpose.historyNote': 'Retiring a purpose keeps it on the visits that hold it, but it cannot be chosen again until it is brought back.',
  'cfg.purpose.code': 'Code',
  'cfg.purpose.codeHint': 'Lowercase letters, digits, hyphen or underscore, for example site_meeting.',
  'cfg.purpose.labelEn': 'Label (English)',
  'cfg.purpose.labelAr': 'Label (Arabic)',
  'cfg.purpose.typesHint': 'Visitor type codes separated by commas; leave empty for every type.',
  'cfg.purpose.modeLabel': 'Visit purpose',
  'cfg.purpose.modeHint': 'Lists are managed in Organisation configuration.',
  'cfg.purpose.mode.free': 'Free text',
  'cfg.purpose.mode.list': 'Only from the purpose list',
  'cfg.purpose.mode.list_or_other': 'From the list, or other',
  'cfg.purpose.choose': 'Choose a purpose…',
  'cfg.purpose.other': 'Other (describe)',
  'cfg.purpose.otherText': 'Describe the purpose',
  'cfg.purpose.listOnly': 'Visitors of this type take their purpose from the list.',
  'cfg.purpose.listOrOther': 'Choose from the list, or “Other” to describe it.',
  'cfg.purpose.retiredOption': '{name} (retired — kept for this visit)',
  'cfg.display.intro': 'Applies to every screen and export for people in this organisation. Each person’s language still decides the words and digits.',
  'cfg.display.dateStyle': 'Date style',
  'cfg.display.clock': 'Clock',
  'cfg.display.date.medium': 'Medium (7 Oct 2026)',
  'cfg.display.date.long': 'Long (7 October 2026)',
  'cfg.display.date.numeric': 'Numeric (07/10/2026)',
  'cfg.display.date.iso': 'ISO (2026-10-07)',
  'cfg.display.clock.locale': 'As the language prefers',
  'cfg.display.clock.h23': '24-hour',
  'cfg.display.clock.h12': '12-hour',
  'cfg.display.preview': 'Preview:',
  'cfg.display.note': 'Times are always shown in the site’s time zone.',
  // Reception desks (OR-16, PD-057).
  'desk.label': 'Your desk',
  'desk.none': 'No desk',
  'desk.hint': 'Names where arrivals and departures are recorded. It does not change what you may do.',
  'desk.recordedAt': 'at {desk}',
  // Cross-site visitors (PB-12-08, PD-058).
  'xsite.label': 'Visitors known at other sites',
  'xsite.hint': 'When a host adds someone they can already see from another site. Approvals and checks are always new for this site; visit history never moves.',
  'xsite.identity': 'Reuse name and contact details only',
  'xsite.identity_and_organisation': 'Reuse name, contact details and organisation',
  'xsite.off': 'Do not reuse — add them as a new visitor',
  // Operating mode and entry basis (PB-02-01, PB-02-04, PB-02-07; PD-059).
  'rcp.d.basis': 'Judged under visitor policy version {version}, facts read at {when}.',
  'rcp.d.basisNoPolicy': 'Facts read at {when}.',
  'mode.title': 'Operating mode',
  'mode.standalone': 'Passage is running on its own: no live external system is relied on. Every visit can be planned, approved, received and closed with a browser or tablet.',
  'mode.integrated': 'Some live integrations are connected. If one is unavailable, the core visit continues by the assisted route shown, and the outcome is recorded as unknown, never as success.',
  'mode.badge.standalone': 'Standalone',
  'mode.badge.integrated': 'Integrated',
  'mode.col.family': 'Integration',
  'mode.col.state': 'Connected',
  'mode.col.fallback': 'When absent or unavailable',
  'mode.none': 'None',
  'mode.live': { one: '1 live connection', other: '{count} live connections' },
  'mode.simulated': { one: '1 simulator (development only)', other: '{count} simulators (development only)' },
  'mode.messaging': 'Last 7 days: {accepted} accepted, {notSent} not sent',
  'mode.family.access_control': 'Access control',
  'mode.family.sso': 'Single sign-on',
  'mode.family.directory': 'Directory',
  'mode.family.identity_verification': 'Identity verification',
  'mode.family.calendars': 'Calendars',
  'mode.family.presence_feeds': 'Gate and device feeds',
  'mode.family.other_connectors': 'Other connectors (HR, printers)',
  'mode.family.messaging': 'Email, SMS and WhatsApp',
  'mode.fallback.access_control': 'Reception issues paper badges or cards by hand; credentials stay "not requested".',
  'mode.fallback.sso': 'People sign in with their Passage password and MFA.',
  'mode.fallback.directory': 'Administrators manage users and hosts in Passage.',
  'mode.fallback.identity_verification': 'A verifier checks the document by hand; nothing is marked verified automatically.',
  'mode.fallback.calendars': 'Hosts plan visits in Passage.',
  'mode.fallback.presence_feeds': 'Reception and kiosks record arrivals and departures.',
  'mode.fallback.other_connectors': 'Staff complete the task by hand.',
  'mode.fallback.messaging': 'Reception shares the pass link or reference in person; unsent messages are listed in the delivery log.',
  // Arrival guidance (PB-13-09, PD-060).
  'guide.field.gate': 'Gate',
  'guide.field.parking': 'Parking',
  'guide.field.building': 'Building',
  'guide.field.floor': 'Floor',
  'guide.field.route': 'Route',
  'guide.field.contact': 'Contact',
  'guide.tab': 'Arrival guidance',
  'guide.title': 'Arrival guidance',
  'guide.intro': 'Gate, parking, building, floor, route and contact guidance for visitors. Narrow it to a visitor type or a destination; the most specific guidance wins for each item.',
  'guide.new': 'Publish guidance',
  'guide.replace': 'Publish a new version',
  'guide.replaceTitle': 'Publish a new version',
  'guide.retire': 'Retire',
  'guide.history': 'Show earlier versions',
  'guide.empty': 'No guidance yet. Invitations and passes use the site instructions only.',
  'guide.version': 'version {number}',
  'guide.status.published': 'In force',
  'guide.status.retired': 'Retired',
  'guide.historyNote': 'Published guidance never changes and is never deleted: a new version replaces it for future invitations and passes, while earlier versions stay here for messages already sent.',
  'guide.dialogHint': 'Leave an item empty to inherit it from wider guidance (for example the whole site).',
  'guide.scopeType': 'Visitor type',
  'guide.scopeTypeHint': 'Only visits of this type get this guidance.',
  'guide.scopeLocation': 'Destination',
  'guide.scopeLocationHint': 'Visits to this location or anywhere inside it.',
  'guide.scope.anyType': 'Every visitor type',
  'guide.scope.wholeSite': 'Whole site',
  'guide.scope.type': 'Type {code}',
  'guide.scope.location': 'At {name}',
  'guide.en': 'English',
  'guide.ar': 'Arabic',
  'guide.note': 'Reason for the change (optional)',
  'guide.publish': 'Publish',
  'guide.visitTitle': 'Arrival guidance',
  'guide.visitIntro': 'What visitors of this visit are told about getting here.',
  // Removing a site policy (PB-12-05, PD-062).
  'override.remove': 'Remove site policy',
  'override.title': 'Remove this site’s own policy',
  'override.subtitle': 'The shared organisation policy will apply here. Check what changes first.',
  'override.from': 'Site policy version {site} gives way to shared policy version {shared}.',
  'override.added': 'Visitor types that appear',
  'override.removed': 'Visitor types that disappear',
  'override.changed': 'Visitor types whose rules change',
  'override.sections': 'Other rules that change',
  'override.none': 'None',
  'override.history': 'Visits already planned keep the policy version they were decided under. The site policy stays in the version history.',
  'override.reason': 'Reason',
  'override.confirm': 'Remove and apply the shared policy',
  // Location deactivation impact (PB-12-04, PD-064).
  'loc.impact.visits': { one: '1 planned visit uses this location.', other: '{count} planned visits use this location.' },
  'loc.impact.visitsBody': ' Move them to another destination or cancel them first.',
  'loc.impact.zones': { one: '1 access-control zone mapping is active. Disable it first.', other: '{count} access-control zone mappings are active. Disable them first.' },
  'loc.impact.rules': 'These rules will stop applying here:',
  'loc.impact.rule.approver_group_member': 'Approver group “{label}” member scoped to this location',
  'loc.impact.rule.arrival_guidance': 'Arrival guidance {label} for this location',
  'loc.impact.confirm': 'I understand these rules stop applying',
  'vform.overnight': 'Overnight: this visit ends on {date}.',
  'vform.gap': 'This time does not exist on {date} because the clocks go forward. Choose a time:',
  'vform.gap.before': 'Use {time} (before the change)',
  'vform.gap.after': 'Use {time} (after the change)',
  'visits.overnight': 'Overnight',
  'visits.clockChange': 'Clocks change during this visit ({from} → {to})',
  'site.context.changed': 'Your working site changed to {working}. This page is for {page}; nothing will be sent until you choose.',
  'site.context.switchBack': 'Switch back to {site}',
  'site.context.restart': 'Start again at {site}',
  'visit.step.exception': 'Needs attention',
  'vpolicy.cred.legend': 'Access credentials for this visitor type',
  'vpolicy.cred.issue': 'Visitors of this type may get access credentials',
  'vpolicy.cred.enclosing': 'Include the zones that lead to the destination (building, floor)',
  'vpolicy.cred.common': 'Include the site’s common zones',
  'vpolicy.cred.tokens': 'Carriers allowed for this type',
  'vpolicy.cred.token.card': 'Card',
  'vpolicy.cred.token.pin': 'PIN',
  'vpolicy.cred.token.qr': 'QR code',
  'vpolicy.cred.token.mobile': 'Mobile credential',
  'vpolicy.cred.hint': 'These settings can only narrow what the site allows; they never add zones or carriers.',
  'pv.rtype.title': 'Retention by visitor type',
  'pv.rtype.intro': 'A visitor type can keep its visit records for a different period than the class rule. Saved to the draft; publish the retention policy to apply.',
  'pv.rtype.none': 'No visitor type has its own retention period. The class rules above apply to every visit.',
  'pv.rtype.type': 'Visitor type code',
  'pv.rtype.typeHint': 'The code from the visitor policy, for example interview.',
  'pv.rtype.days': '{name}: days after the visit ends',
  'pv.rtype.add': 'Add to draft',
  'pv.rtype.remove': 'Remove',
  'pv.rtype.action': 'Action',
  'person.source': 'From {source}, {date}',
  'person.source.staff_entry': 'staff entry',
  'person.source.walk_in': 'reception walk-in',
  'person.source.visitor_self_service': 'the visitor',
  'person.source.record_import': 'a record import',
  'person.source.roster_import': 'a roster import',
  'person.source.calendar': 'a calendar invitation',
  'person.source.contractor_register': 'the contractor register',
  'person.source.subject_request': 'a privacy correction request',
  'vform.noCreateHere': 'You cannot plan visits at {site}. Choose a site where you can.',
  'vform.planAt': 'Plan at {site}',
} as const;
